<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import MessageInsightPanel from '../MessageInsightPanel.vue';
import { readMessageIntelligence } from '../intelligence.js';
import { useMessageContext } from '../provider.js';

const { t } = useI18n();
const { attachments, contentAttributes } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});

const transcriptionInsight = computed(() =>
  readMessageIntelligence({
    type: 'audio',
    contentAttributes: contentAttributes.value,
    attachment: attachment.value,
  })
);
</script>

<template>
  <div class="flex w-full max-w-[34rem] flex-col gap-2">
    <BaseBubble class="bg-transparent" data-bubble-name="audio">
      <AudioChip
        :attachment="attachment"
        class="skip-context-menu p-2 text-lais-text"
      />
    </BaseBubble>
    <MessageInsightPanel
      :title="t('CONVERSATION.MESSAGE_INSIGHTS.AUDIO_TRANSCRIPTION.TITLE')"
      :body="transcriptionInsight.text"
      :state="transcriptionInsight.state"
      :loading-label="
        t('CONVERSATION.MESSAGE_INSIGHTS.AUDIO_TRANSCRIPTION.LOADING')
      "
      :error-label="
        t('CONVERSATION.MESSAGE_INSIGHTS.AUDIO_TRANSCRIPTION.ERROR')
      "
    />
  </div>
</template>
